import { Box, forwardRef } from '@chakra-ui/react'

export const FetchingIndicator = forwardRef(({ isFetching, ...props }, ref) => {
    return (
        <Box
            ref={ref}
            {...{ inert: isFetching ? '' : undefined }}
            sx={{
                '&[inert]': {
                    opacity: 0.5,
                    transition: '.3s',
                },
            }}
            {...props}
        />
    )
})
